<div class="image-cropper-wrap" #cropperContainer
     [class.no-aspect-ratios]="noAspectRatio">
  <div class="image-cropper" [style.height]="containerHeight" #cropper></div>
  <div class="slider-label screen-d-xl-none"
       [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.slideToZoom'">
  </div>
</div>
